module.exports = __webpack_public_path__ + "img/kawaii.45c28896.jpeg";